export * from './core.module';
export * from './services/user.service';
export * from './services/project.service';
export * from './services/job.service';
export * from './services/loader.service';
export * from './services/studio.service';
export * from './services/team.service';
export * from './services/offer.service';
export * from './services/product.service';
export * from './services/media.service';
export * from './services/documentSegment.service';
export * from './services/permissions.service';
export * from './services/auth-guard.service';
export * from './services/file-uploader.service';
export * from './services/messaging.service';
export * from './services/report.service';
export * from './animations/list-animations';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/index.ts